import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class NotFoundGuard  {
  constructor(private router: Router) { }
  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    const pathname = window.location.pathname;

    // temporary hack. need review.
    if (`${state.url}`.includes('/prevention-wellness')) {
      this.router.navigate(['prevention-wellness']);
      return true;
    }

    if (pathname && (pathname[pathname.length-1] !== '/')) {
      const redirectTo = window.location.href.replace(pathname, pathname + '/');
      window.location.href = redirectTo;
      return;
    }
    return this.router.createUrlTree(['/results'])
  }

}
